module.exports = __webpack_public_path__ + "static/thumb-atlantis-551d02ba64912c61f6fdea6bd73831c7.jpg";